import html2canvas from 'html2canvas';
import Canvg from 'canvg';

export const getBlobfromSVG = (svgString) => {
    return new Promise((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            var v = Canvg.fromString(ctx, `${svgString}`);

            v.start();

            // add watermark
            ctx.font = "13px sans-serif";
            ctx.fillStyle = "#9a9a9a";
            ctx.fillText("Powered by acuitusag", 10, canvas.height - 3);

            canvas.toBlob(blob => resolve(blob));
        }
        catch (ex) {
            reject(ex);
        }
    });
}

export const getComponentAsBlob = (element) => {
    return new Promise(async (resolve, reject) => {
        try {
            const canvas = await html2canvas(element, {
                scrollY: -(window.scrollY),
                useCORS: true,
                height: element.scrollHeight,
                width: element.scrollWidth,
            });
            removeCloneChartElement(element);
            canvas.toBlob(blob => resolve(blob));
        } catch (ex) {
            reject(ex);
        }
    });
}

export const getCloneFarmChartElement = (element) => {
    const clonedElement = document.createElement('div');
    clonedElement.id = "clone-element-container";

    clonedElement.appendChild(element.cloneNode(true));

    clonedElement.querySelector('.facebook-share').classList.add('d-none');
    clonedElement.querySelector('.image-watermark').classList.remove('d-none');

    document.body.appendChild(clonedElement);
    return clonedElement;
}


export const getCloneGanttChartElement = (element) => {
    const clonedElement = document.createElement('div');
    clonedElement.id = "gantt-clone-container";

    clonedElement.appendChild(element.cloneNode(true));

    clonedElement.querySelector('.gantt-chart-share').classList.add('d-none');
    clonedElement.querySelector('.image-watermark').classList.remove('d-none');

    document.body.appendChild(clonedElement);
    return clonedElement;
}

export const removeCloneChartElement = (element) => {
    element && document.body.removeChild(element);
}
